import React from "react";
import { useTranslation } from "react-i18next";
import CustomDateDialog from "components/sort-by/custom-date.dialog";
import Input from "components/input-fields/input-fields";
import { MenuItem } from "@mui/material";
import {formatDate} from "../../helpers/data";

interface SortByComponentProps {
  value?: string;
  defaultValue?: any;
  list: any[];
  label?: string;
  onChange: (value: string) => void;
  date: boolean;
}

function SortByComponent({ value, defaultValue, list, onChange, date = false, label = "" }: SortByComponentProps) {
  const { t } = useTranslation();
  const [sortBy, setSortBy] = React.useState(defaultValue || 0);
  const [customDate, setCustomDate] = React.useState("custom");
  const [showCustomDate, setShowCustomDate] = React.useState(false);
  const isControlled = !!value;
  const sortValue = isControlled ? value : sortBy;
  
  function handleChange(sortBy: string) {
    if (!isControlled) {
      setSortBy(sortBy);
      if (showCustomDate) {
        setCustomDate('custom');
      }
    }
    onChange && onChange(sortBy);
  }

  function handleChangeCustomDate(date: { from: string; to: string }) {
    setSortBy(JSON.stringify(date));
    setCustomDate(JSON.stringify(date));
    onChange && onChange(JSON.stringify(date));
  }

  function displayCustomLabel() {
    let date;
    try {
      date = JSON.parse(customDate);
      if (!showCustomDate) {
        return formatDate(date.from) + " - " + formatDate(date.to);
      } else {
        return t("common:sort.customDate");
      }
    } catch (e) {
      return t("common:sort.customDate");
    }
  }
  return (
    <>
      <Input
        label={label}
        type="select"
        value={sortValue}
        onChange={(e) => handleChange(e.target.value)}
        defaultValue={defaultValue}
      >
        {list.map((option) => {
          return (
            <MenuItem key={option.value} value={option.value}>
              {t(option.label)}
            </MenuItem>
          );
        })}
        {date ? (
          <MenuItem onClick={() => setShowCustomDate(true)} value={customDate}>
            {displayCustomLabel()}
          </MenuItem>
        ) : null}
      </Input>
      <CustomDateDialog
        show={showCustomDate}
        onHide={() => setShowCustomDate(false)}
        onChange={(date) => {
          handleChangeCustomDate(date);
          setShowCustomDate(false);
        }}
      />
    </>
  );
}

export default SortByComponent;
